/**
  * 本地存取token/用户等相关信息
  *
  * @author qingguipeng
  * @since 2019年8月26日11:17:48
  */
const storage = {
  getJson(key) {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch (err) {
      return null
    }
  },
  setJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (err) {
      return false
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value);
      return true
    } catch (err) {
      return false
    }
  },

  get(key, value) {
    try {
      return localStorage.getItem(key, value);
    } catch (err) {
      return false
    }
  },

  del(key) {
    localStorage.removeItem(key)
  }
};

export const NOTICES = {
  "BIRTHDAY": 1, //生日
  "ACTIVITYNOTICE": 2, //活动通知
  "APRIREDPACKET": 3, //春游踏青活动
  "MAYREDPACKET": 4, //五月满减券活动
  "JUNEPRENOTICE": 5, //6.18年中大促
  "OPERATION": 6, //未开奖的红包
  "INVESTMSG": 7, //投资通知
  "MIDACTIVITY": 8, //中秋活动
  "RATECOUPONNOTICE": 9, //加息券通知
}


export default storage
